<div class="scoring-definitions">
  @for (scoringDefinition of scoringDefinitions; let index = $index; track index) {
    <div>
      <crm-scoring-definition-card
        [scoringDefinition]="scoringDefinition"
        (scoringDefinitionChange)="handleScoringDefinitionChange(index, $event)"
        [objectType]="objectType"
        [disabled]="disabled"
        (modified)="handleCardModified()"
      ></crm-scoring-definition-card>
    </div>
  }
</div>
